module.exports = __webpack_public_path__ + "f7608604b4043e45b5fcbea644386397.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/visa_2022_chart.png
// module id = 1752
// module chunks = 0